var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropzoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00065 26.6667C7.26732 26.6667 6.63932 26.4054 6.11665 25.8827C5.59399 25.36 5.3331 24.7325 5.33399 24V20H8.00065V24H24.0007V20H26.6673V24C26.6673 24.7334 26.406 25.3614 25.8833 25.884C25.3607 26.4067 24.7331 26.6676 24.0007 26.6667H8.00065ZM16.0007 5.33337L22.6673 12L20.8007 13.9334L17.334 10.4667V21.3334H14.6673V10.4667L11.2007 13.9334L9.33399 12L16.0007 5.33337Z",
    fill: "#0B93E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropzoneIcon);
export default __webpack_public_path__ + "static/media/dropzone-icon.e8918bb73198521d12973914502cfd42.svg";
export { ForwardRef as ReactComponent };